import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const findLocationDocuments = createAsyncThunk(
  "locationShow/findLocationDocuments",
  async (id: string, { rejectWithValue }) => {
    try {
      const url = new URL(
        `${api.baseURL}document/get-category-and-document-location?location=${id}`,
      );
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      if (!data) {
        throw new Error("No se encontró");
      }
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
